module.exports = __webpack_public_path__ + "static/img/AT@3x.24aa7cd4.jpg";